import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SvgIcon } from "@cinch-labs/design-system";
import classnames from "classnames";
import React from "react";
import styles from "./accordion.module.css";
const handleArrowDown = (accordionIndex, totalItems)=>{
    const nextAccordionIndex = accordionIndex + 1;
    if (accordionIndex === totalItems) {
        return 1;
    }
    return nextAccordionIndex;
};
const handleArrowUp = (accordionIndex, totalItems)=>{
    const nextAccordionIndex = accordionIndex - 1;
    if (accordionIndex === 1) {
        return totalItems;
    }
    return nextAccordionIndex;
};
const getOpenAccordionKeyCode = (id)=>({
        "13": ()=>id,
        "32": ()=>id
    });
const getKeyCodes = (id, totalItems)=>({
        "40": ()=>handleArrowDown(id, totalItems),
        "38": ()=>handleArrowUp(id, totalItems),
        "36": ()=>1,
        "35": ()=>totalItems
    });
const AccordionButton = ({ isExpanded , id , toggleExpanded , buttonText , totalItems , setFocusActive , buttonId , sectionId , iconType , iconGradient  }, ref)=>{
    const iconGradientFill = iconGradient ? iconGradient : undefined;
    const iconColorFill = !iconGradient ? "deepPurple" : undefined;
    const keyboardEventHandler = (event)=>{
        const keyCodes = getKeyCodes(id, totalItems);
        const openAccordionKeyCode = getOpenAccordionKeyCode(id);
        if (event.keyCode in openAccordionKeyCode) {
            event.preventDefault();
            toggleExpanded();
            return;
        }
        if (event.keyCode in keyCodes) {
            event.preventDefault();
            setFocusActive(keyCodes[event.keyCode]());
            return;
        }
    };
    return /*#__PURE__*/ _jsx("h3", {
        className: styles.accordionTitle,
        children: /*#__PURE__*/ _jsxs("button", {
            type: "button",
            "aria-expanded": isExpanded,
            "aria-disabled": isExpanded,
            "aria-controls": `${sectionId}-${id}`,
            id: `${buttonId}-${id}`,
            "data-testid": `${buttonId}-${id}`,
            onClick: toggleExpanded,
            onKeyDown: keyboardEventHandler,
            ref: ref,
            className: styles.accordionButton,
            children: [
                iconType ? /*#__PURE__*/ _jsx(SvgIcon, {
                    name: iconType,
                    className: styles.icon,
                    color: iconColorFill,
                    size: 24,
                    gradient: iconGradientFill
                }) : null,
                buttonText,
                /*#__PURE__*/ _jsx(SvgIcon, {
                    name: "chevron-down",
                    className: classnames(styles.chevron, {
                        [styles.chevronRotate]: isExpanded
                    }),
                    color: "deepPurple",
                    size: 16
                })
            ]
        })
    });
};
export default /*#__PURE__*/ React.forwardRef(AccordionButton);
